// PWA service-worker registration. Only registers in production builds where
// HTTPS is available — webpack dev server doesn't serve the SW correctly.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Skip on http (except localhost) where SW APIs are blocked
  const isSecure = window.location.protocol === "https:" || window.location.hostname === "localhost";
  if (!isSecure) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        // Failure is non-fatal — site still works without the SW.
        console.warn("[pwa] service worker registration failed:", err);
      });
  });
}
